var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useContext } from 'react';
import { TabListContext } from './TabListContext';
export const useTabListContext = () => {
    _react_refresh_temp_1();
    const value = useContext(TabListContext);
    if (!value) {
        throw new Error('Tab list context not provided!');
    }
    return value;
};
_react_refresh_temp_1(useTabListContext, "ksutO2/Ix3UeCrGnhyM+QEP505Y=");
